import { Component, Input, forwardRef } from '@angular/core';
import { DashboardBaseComponent } from '../shared/dashboard-base-component';

export interface TarjetaKpiComparisonItem {
  label: string;
  value: string;
  pct: number;
  color: string;
}

export interface TarjetaKpiComparisonData {
  title: string;
  sub?: string;
  lastUpdated?: string;
  items: [TarjetaKpiComparisonItem, TarjetaKpiComparisonItem];
}

@Component({
  selector: 'app-tarjeta-kpi-comparison',
  templateUrl: './tarjeta-kpi-comparison.component.html',
  styleUrls: [
    '../tarjeta-kpi/tarjeta-kpi.component.scss',
    './tarjeta-kpi-comparison.component.scss'
  ],
  standalone:true,
  providers: [
    {
      provide: DashboardBaseComponent,
      useExisting: forwardRef(() => TarjetaKpiComparisonComponent)
    }
  ]
})
export class TarjetaKpiComparisonComponent extends DashboardBaseComponent {
  private _data!: TarjetaKpiComparisonData;

  @Input() set data(val: TarjetaKpiComparisonData) {
    this._data = val;
    if (val) this.isLoaded = true;
  }
  get data() { return this._data; }
}
